import React, { Fragment, useEffect, useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";
import { useNavigate, useParams } from "react-router-dom";
import { formregdelete, formreglist, formuserconvert, schformdetail } from "../../../../services/superadmin";
import moment from "moment";
import { schoollistmaster } from "../../../../services/master";
import Select from "react-select";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import exportUrl from "../../../../exportUtl";

export const FormList = () => {
    const { id } = useParams();
    const [filterProduct, setFilterProduct] = useState([]);
    const [fname, setFName] = useState("");
    const navigate = useNavigate();
    const [submitted, setSubmitted] = useState("");

    const sorting = useMemo(() => {
        return ['asc', 'desc',];
    }, []);

    const columnDefs = [
        {
            headerName: "Actions",
            field: "id",
            width: 130,
            resizable: true,
            filter: false,
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        {localStorage.getItem("Role") === '1' &&
                            <a
                                onClick={() => delctype(params.data)} title="Form Delete"
                                className="btn-sm btn-danger me-2"
                            >
                                <i className="fa fa-trash fa-lg"></i>
                            </a>
                        }

                        <a
                            onClick={() => viewctype(params.value)} title="Form Details"
                            className="btn-sm btn-secondary me-2"
                        >
                            <i className="fa fa-eye fa-lg"></i>
                        </a>
                        {localStorage.getItem("Role") === '1' &&
                            <>
                                {params.data.user_conversion_status == 0 ? (
                                    <a
                                        onClick={() => viewuser(params.data)} title="Convert User"
                                        className="btn-sm btn-success me-2"
                                    >
                                        <i className="fa fa-user fa-lg"></i>
                                    </a>
                                ) : (
                                    <a
                                        title="User Converted"
                                        className="btn-sm btn-warning me-2"
                                    >
                                        <i className="fa fa-check fa-lg"></i>
                                    </a>
                                )

                                }
                            </>
                        }



                    </div>

                );
            },
        },
        {
            headerName: "Name",
            field: "name",
            width: 120,
            sortable: true,
            resizable: true,
            sorting: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Eligible Age Category",
            field: "age_category",
            width: 150,
            sortable: true,
            resizable: true,
            sorting: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Achievement Score",
            field: "achievement_score",
            width: 150,
            sortable: true,
            resizable: true,
            sorting: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "DOB",
            field: "dob",
            width: 120,
            sortable: true,
            resizable: true,
            sorting: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Gender",
            field: "gender",
            width: 100,
            sortable: true,
            resizable: true,
            sorting: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Sport",
            field: "sport_name",
            width: 150,
            sortable: true,
            resizable: true,
            sorting: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Phone Number",
            field: "mobile_number",
            width: 120,
            sortable: true,
            resizable: true,
            sorting: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Email",
            field: "email_id",
            width: 120,
            sortable: true,
            resizable: true,
            sorting: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Educational Qualification",
            field: "highest_educational_qualification",
            width: 150,
            sortable: true,
            resizable: true,
            sorting: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Submitted Date & Time",
            field: "created_at",
            width: 180,
            sortable: true,
            resizable: true,
            sorting: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
    ];



    useEffect(() => {
        schformdetail(id).then((res) => {
            if (res.status === true) {
                setFName(res.data.scholarship_form.form_name);
            }
        })

        schoollistmaster().then((response) => {
            if (response.status === true) {
                let arr = [];

                if (response.data.details.length !== 0) {
                    for (let i = 0; i < response.data.details.length; i++) {
                        arr.push({
                            value: response.data.details[i].id,
                            label:
                                response.data.details[i].school_unique_no +
                                " - " +
                                response.data.details[i].school_name,
                        });
                    }
                }
                setSList(arr);
            }
        })
        listall();
    }, []);

    function listall() {
        setFilterProduct([]);
        formreglist(id).then((response) => {
            if (response.status === true) {
                const sdata = response.data.data.list.map((item) => ({
                    ...item,
                    dob: moment(item.dob).format("DD-MM-YYYY"),
                    created_at: moment(item.created_at).format("DD-MM-YYYY HH:mm:ss"),
                }));
                setFilterProduct(sdata)
            }
        })
    }

    function delctype(data) {
        Swal.fire({
            text: "Are you sure want to Delete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ac0404",
            cancelButtonColor: "#6259ca",
            confirmButtonText: "Delete",
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                dotracking(
                    "delete icon in form list for " + data.name + " (" + data.id + ") $$ " + trackobj.formcompheading
                )
                formregdelete(data.id).then((response) => {
                    if (response.status === true) {
                        listall();
                        toast.success(response.message)
                    }
                })
            }
        });
    }
    function viewctype(did) {

        dotracking("back button in registered form list for " + fname + " (" + id + ") $$ " + trackobj.formdetheading);
        if (localStorage.getItem("Role") === '8') {
            navigate("/funder/formregisterdetail/" + id + "/" + did)
        } else if (localStorage.getItem("Role") === '3') {
            navigate("/cityregional/formregisterdetail/" + id + "/" + did)
        } else {
            navigate("/superadmin/formregisterdetail/" + id + "/" + did)
        }

    }

    function explist() {
        dotracking(
              "export button in registered form list for " +
              fname +
              " (" +
              id +
              ") $$ " +
              trackobj.formlistheading
            );
        window.open(
            exportUrl + "api/scholarship-form-export/" + id,
            "_blank"
        );
    }
    function backlist() {
        dotracking("back button in registered form list for " + fname + " (" + id + ") $$ " + trackobj.schlistheading);
        if (localStorage.getItem("Role") === '8') {
            navigate("/funder/scholarshipformlist")
        } else if (localStorage.getItem("Role") === '3') {
            navigate("/cityregional/scholarshipformlist")
        } else {
            navigate("/superadmin/scholarshipformlist")
        }
    }
    const [show, setShow] = useState(false);
    const [uesid, setUESID] = useState("");
    const [slist, setSList] = useState([]);
    const [schid, setSchId] = useState("");
    const [fdetail, setFDetail] = useState("");

    function viewuser(usr) {
        setShow(true);
        setUESID("");
        setSchId("");
        console.log(usr)
        setFDetail(usr);
    }
    function handleSch(e) {
        if (e != null) {
            setSchId(e);
        } else {
            setSchId("");
        }

    }

    function handleSubmit(e) {
        e.preventDefault();
        setSubmitted(true);
        if (uesid !== "" && schid !== "") {
            const temp = new FormData();
            temp.append('old_user_id', uesid)
            temp.append('school_id', schid.value)
            temp.append('admin_id', localStorage.getItem("UID"));
            temp.append('form_data_id', fdetail.id)
            temp.append('form_details_id', id)
            dotracking("convert user button in registered form list for the user " + fdetail.name + " ( " + fdetail.id + ") to ESID - " + uesid + " , School - " + schid.label + "(" + schid.value + ") in " + fname + " (" + id + ") $$ " + trackobj.formconvertheading);
            formuserconvert(temp).then((res) => {
                if (res.status === true) {
                    setSubmitted(false);
                    setShow(false);
                    setFDetail("");
                    if (res.data.success === false) {
                        Swal.fire({
                            text: res.data.message,
                            icon: "error",
                            showCancelButton: false,
                            confirmButtonColor: "#ac0404",
                            confirmButtonText: "Ok",
                            allowOutsideClick: false,
                        })
                    } else {
                        toast.success(res.data.message);
                    }

                }
            })
        }
    }

    return (
        <div className="side-app">
            <div className="page-header">
                <div className="breadcrumb">
                    <h4 className="mb-0">Registered Form Lists</h4>
                </div>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Scholarship Form</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Registered Form Lists
                    </li>
                </ol>
            </div>

            <div className="row">
                <div className="col-12">
                    <form className="card mt-0">

                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-7">
                                    <h3>{fname}</h3>
                                </div>
                                <div className="col-md-5">
                                    <div className="text-right">
                                        <a className="btn btn-gray me-2" onClick={backlist}>
                                            <i className="fe fe-corner-up-left"></i> Back
                                        </a>
                                        <a className="btn btn-secondary me-2" onClick={explist}>
                                            <i className="fa-solid fa-file-export"></i> Export
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="ag-theme-alpine ag-style mt-2">
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    rowData={filterProduct}
                                    pagination="true"
                                    paginationPageSize="10"
                                    sortingOrder={sorting}
                                    suppressExcelExport={true}
                                    suppressDragLeaveHidesColumns={true}
                                    domLayout="autoWidth"
                                    onGridReady={(params) => {
                                        params.api.sizeColumnsToFit();
                                    }}
                                />
                            </div>

                            <Modal show={show} centered size="sm">
                                <Modal.Header>
                                    <h4>Convert User</h4>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="form-group">
                                        <label className="form-label">
                                            ESID <span className="errortext"> *</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="ESID"
                                            value={uesid}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const sanitizedValue = value.replace(/[^a-zA-Z0-9]/g, '');
                                                setUESID(sanitizedValue);
                                            }}
                                        />
                                        {submitted && !uesid && (
                                            <span className="errortext">ESID is required</span>
                                        )}
                                    </div>
                                    <div className="form-group">
                                        <label className="form-label">
                                            School <span className="errortext"> *</span>
                                        </label>
                                        <Select
                                            className="dropdown"
                                            placeholder="Select School"
                                            value={schid}
                                            options={slist}
                                            onChange={handleSch}
                                            isSearchable={true}
                                            isClearable
                                            hidden
                                        />
                                        {submitted && !schid && (
                                            <span className="errortext">School is required</span>
                                        )}
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => { setShow(false); setFDetail("") }}>
                                        Cancel
                                    </Button>
                                    <Button variant="success" onClick={handleSubmit}>
                                        Submit
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    </form>
                </div>
            </div>
        </div>


    );
};
